/* Barra di ritorno al percorso guidato — Lady&Oscar
   ---------------------------------------------------
   Sulle pagine collezione, quando l'indirizzo porta ?pg=ramo/sottoramo/scelta,
   ricostruisce le briciole di pane del percorso e permette di risalire di un
   passo invece di dover ricominciare dalla home.

   Legge lo stesso albero del blocco in home (snippets/percorso-albero).
   Se il parametro non c'e', la barra resta nascosta: chi arriva dal menu o da
   Google non vede nulla. */

(function () {
  'use strict';

  function init(root) {
    if (root.dataset.pgrReady === '1') return;
    root.dataset.pgrReady = '1';

    var m = /[?&]pg=([^&]+)/.exec(location.search);
    if (!m) return;

    var dataEl = root.querySelector('[data-pg-data]');
    var trailEl = root.querySelector('[data-pgr-trail]');
    if (!dataEl || !trailEl) return;

    var tree;
    try {
      tree = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var slugs = decodeURIComponent(m[1]).split('/').filter(Boolean);
    if (!slugs.length) return;

    // Cammina l'albero seguendo gli id: raccoglie i nodi attraversati e si
    // ferma sulla destinazione finale (il nodo con url).
    var nodo = tree;
    var passi = [];
    for (var i = 0; i < slugs.length; i++) {
      var next = (nodo.options || []).filter(function (o) { return o.id === slugs[i]; })[0];
      if (!next) break;
      passi.push(next);
      if (next.url) break;
      nodo = next;
    }
    if (!passi.length) return;

    function crumb(testo, href, corrente) {
      var li = document.createElement('li');
      li.className = 'pgr__item';
      var el = document.createElement(href ? 'a' : 'span');
      el.className = 'pgr__crumb' + (corrente ? ' pgr__crumb--current' : '');
      el.textContent = testo;
      if (href) {
        el.href = href;
      } else {
        el.setAttribute('aria-current', 'page');
      }
      li.appendChild(el);
      return li;
    }

    function separatore() {
      var li = document.createElement('li');
      li.className = 'pgr__sep';
      li.setAttribute('aria-hidden', 'true');
      li.textContent = '›';
      return li;
    }

    trailEl.appendChild(crumb(tree.home || 'Inizio', '/', false));

    var percorsi = [];
    passi.forEach(function (passo, i) {
      var ultimo = i === passi.length - 1;
      trailEl.appendChild(separatore());
      if (passo.id) percorsi.push(passo.id);
      // L'ultimo passo e' la pagina in cui siamo: testo, non link.
      // Gli altri riaprono il percorso esattamente a quella domanda.
      var href = ultimo ? null : '/#percorso=' + percorsi.join('/');
      trailEl.appendChild(crumb(passo.label, href, ultimo));
    });

    root.hidden = false;
  }

  function boot() {
    document.querySelectorAll('[data-pgr]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();